import { ExtensionProperty, IProperty, Nullable, PropertyType } from "@gltf-transform/core3";
import { CYNCLY_ITEMS_METADATA } from "../constants";
import { AnyGeometryType, IClassificationMetadata } from "./cyncly-items-metadata";

interface IItemMetadata extends IProperty {
	classification: IClassificationMetadata | null;
	geometryType: AnyGeometryType | null;
	instanceId: string | null;
	itemId: string | null;
	subItemScope: string | null;
	visible: boolean | null;
}

/**
 * Defines Item metadata attached to a {@link Node}. See {@link CYNCLYItemsMetadata}.
 */
export class ItemMetadata extends ExtensionProperty<IItemMetadata> {
	public static EXTENSION_NAME = CYNCLY_ITEMS_METADATA;
	public extensionName = CYNCLY_ITEMS_METADATA;
	public propertyType = "ItemMetadata";
	public parentTypes = [PropertyType.NODE];

	protected init(): void {
		this.extensionName = CYNCLY_ITEMS_METADATA;
		this.propertyType = "ItemMetadata";
		this.parentTypes = [PropertyType.NODE];
	}

	protected getDefaults(): Nullable<IItemMetadata> {
		return Object.assign(super.getDefaults() as IProperty, {
			geometryType: null,
			instanceId: null,
			itemId: null,
			subItemScope: null,
			visible: null,
			classification: null,
		});
	}

	public getGeometryType(): AnyGeometryType | null {
		return (this as any).get("geometryType");
	}

	public setGeometryType(geometryType: AnyGeometryType | null): this {
		return (this as any).set("geometryType", geometryType);
	}

	public getInstanceId(): string | null {
		return (this as any).get("instanceId") as string | null;
	}

	public setInstanceId(instanceId: string | null): this {
		return (this as any).set("instanceId", instanceId);
	}

	public getItemId(): string | null {
		return (this as any).get("itemId");
	}

	public setItemId(itemId: string | null): this {
		return (this as any).set("itemId", itemId);
	}

	public getSubItemScope(): string | null {
		return (this as any).get("subItemScope");
	}

	public setSubItemScope(subItemScope: string | null): this {
		return (this as any).set("subItemScope", subItemScope);
	}

	public isVisible(): boolean | null {
		return (this as any).get("visible");
	}

	public setVisible(visible: boolean | null): this {
		return (this as any).set("visible", visible);
	}

	public getClassification(): IClassificationMetadata | null {
		return (this as any).get("classification");
	}

	public setClassification(classification: IClassificationMetadata | null): this {
		return (this as any).set("classification", classification);
	}
}
